export default __webpack_public_path__ + "static/media/calendar-black.cb4205ce.svg";